<template>
  <AppLayout pageTitle="Dashboard">
    <div class="grid grid-cols-1 sm:grid-cols-12 gap-y-8 sm:gap-y-0 sm:gap-x-8">
      <div class="sm:col-span-8">
        <AlertDisplay variant="info" class="mb-4" heading="Changes to Collections">
          We've made some changes to how accounts and collections work. If you have issues viewing your roster items, please log
          out and log back in. If you have any questions or issues, please use the feedback form at the bottom right.
        </AlertDisplay>

        <GettingStarted />

        <CollectionsSummary v-if="accountStore.hasCurrentAccount" />
      </div>
      <div class="sm:col-span-4">
        <AppUpdateList />
      </div>
    </div>
  </AppLayout>
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head';

import { useAccountStore } from '@/stores';

import AppLayout from '@/layouts/AppLayout.vue';
import AlertDisplay from '@/components/AlertDisplay.vue';
import AppUpdateList from '@/components/AppUpdateList.vue';
import CollectionsSummary from '@/components/collections/CollectionsSummary.vue';
import GettingStarted from '@/components/home/GettingStarted.vue';

const accountStore = useAccountStore();

useHead({
  title: 'Home',
});
</script>
